import css from '@emotion/css';

/* tslint:disable:max-line-length */

export const colors = {
  brand: '#663399',
  lilac: '#9d7cbf',
  accent: '#ffb238',
  success: '#37b635',
  link: 'rgba(0, 0, 0, .5)',
  warning: '#ec1818',
  ui: {
    bright: '#e0d6eb',
    light: '#f5f3f7',
    whisper: '#fbfafc'
  },
  code: '#fcf6f0',
  gray: {
    dark: 'hsla(270, 17.119554496%, 0%, 0.92)',
    copy: 'hsla(270, 15.797828016000002%, 0%, 0.88)',
    calm: 'rgba(0, 0, 0, 0.54)'
  },
  white: '#fff',
  grey: '#CCC',
  black: '#000'
}

export const fonts = {
  sansSerif:
    'josefin sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif',
  serif: 'Georgia, "Times New Roman", Times, serif',
  monospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
}

export const breakpoints = [
  '40em',
  '52em',
  '64em'
]

export const widths = {
  md: 720,
  lg: 960,
  xl: 1140
}

export const dimensions = {
  fontSize: {
    regular: 16,
    large: 18
  },
  headingSizes: {
    h1: 2.441,
    h2: 1.953,
    h3: 1.563,
    h4: 1.25
  },
  lineHeight: {
    regular: 1.45,
    heading: 1.2
  },
  containerPadding: 1.5
}

export const heights = {
  header: 60
}

export const linkCSS = css`
  cursor: pointer;
  color: ${colors.link};

  &:hover,
  &:focus {
    color: ${colors.black};
    text-decoration: none;
  }
`

export const linkCSSInverted = css`
  cursor: pointer;
  color: ${colors.grey};

  &:hover,
  &:focus {
    color: ${colors.white};
    text-decoration: none;
  }
`

export const theme = {
  colors,
  dimensions,
  breakpoints,
}